import { GET_SOCIAL_STATUSES } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_SOCIAL_STATUSES] (state, statuses) {
    state.all = statuses
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/socialStatuses.js